import React from "react";

const EmptyClassSearches = ({ emptyClassSearches, emptyViewCount = 0, days = 30 }) => {
  const totalSearches = emptyClassSearches?.totalSearches || emptyViewCount || 0;

  if (totalSearches <= 0) {
    return (
      <article className="owner-dashboard__panel owner-dashboard__empty-searches owner-dashboard__empty-searches--clear">
        <div className="owner-dashboard__panel-header owner-dashboard__panel-header--compact">
          <div>
            <h3 className="owner-dashboard__panel-title">Class searches with no results</h3>
            <p className="owner-dashboard__panel-subtitle">
              Last {days} days · families who searched and found no matching classes
            </p>
          </div>
        </div>
        <p className="owner-dashboard__usage-note">
          No dead-end class searches in the last {days} days — every tracked search
          found at least one matching class.
        </p>
      </article>
    );
  }

  const {
    headline,
    searches = [],
    hasBreakdown = false,
    hasFullDetails = false,
  } = emptyClassSearches || {};

  const fallbackHeadline = `${totalSearches} famil${
    totalSearches === 1 ? "y" : "ies"
  } searched for classes and saw “no classes match.”`;

  return (
    <article className="owner-dashboard__panel owner-dashboard__empty-searches">
      <div className="owner-dashboard__panel-header owner-dashboard__panel-header--compact">
        <div>
          <h3 className="owner-dashboard__panel-title">Class searches with no results</h3>
          <p className="owner-dashboard__panel-subtitle">
            Last {days} days · age, days, and program for each failed search
          </p>
        </div>
      </div>

      <p className="owner-dashboard__usage-headline owner-dashboard__usage-headline--alert">
        {headline || fallbackHeadline}
      </p>

      {hasBreakdown && searches.length > 0 ? (
        <>
          <div className="owner-dashboard__empty-searches-table-wrap">
            <table className="owner-dashboard__empty-searches-table">
              <thead>
                <tr>
                  <th scope="col">Program</th>
                  <th scope="col">Child&apos;s age</th>
                  <th scope="col">Days searched</th>
                  <th scope="col">Time</th>
                  <th scope="col">Times</th>
                </tr>
              </thead>
              <tbody>
                {searches.map((row) => (
                  <tr key={row.id}>
                    <td>{row.program}</td>
                    <td>{row.ageLabel}</td>
                    <td>{row.daysLabel}</td>
                    <td>{row.timeLabel}</td>
                    <td>{row.count.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <ul className="owner-dashboard__empty-searches-details">
            {searches.slice(0, 8).map((row) => (
              <li key={`detail-${row.id}`}>
                <strong>{row.count.toLocaleString()}×</strong> {row.summary}
                {row.reasonLabel ? ` — ${row.reasonLabel}` : ""}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="owner-dashboard__empty-searches-note">
          {totalSearches} failed search{totalSearches === 1 ? "" : "es"} were recorded,
          but search details (age, days) aren&apos;t available for that period yet.
          New searches after the site update will show full details here.
        </p>
      )}

      {!hasFullDetails && hasBreakdown && (
        <p className="owner-dashboard__empty-searches-note">
          Some rows may only show the program until more searches are recorded with
          the updated tracking.
        </p>
      )}

      <p className="owner-dashboard__empty-searches-note">
        Includes the homepage class finder and filters on program pages.
      </p>
    </article>
  );
};

export default EmptyClassSearches;
